module.exports = __webpack_public_path__ + "static/media/1.749b94f5.jpg";